import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapDaoService {
  apiUrl: string;
  constructor(private http: HttpClient) {
    this.apiUrl = environment.API_ENDPOINT;
  }

  getMapUsers(mapId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/map/${mapId}/user`);
  }

  getMapEnterprisePermissions(mapId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/map/${mapId}/enterprise/permissions`);
  }

  getAvailableMapVersions(mapId: string) {
    return this.http.get(`${this.apiUrl}/map/${mapId}/versions`);
  }

  softDeleteMap(mapId: string): Observable<string> {
    return this.http.put(`${this.apiUrl}/map/${mapId}`, {state: 'deleted'}, {responseType: 'text'});
  }
}
